import { Colors } from '@zapier/design-system';
import { createBuilderModule } from '../../../builder';
import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { AnimationsSection } from './AnimationsSection';
import { DEFAULT_VALUES } from './fixtures';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withTracking(AnimationsSection, {
    as: 'section',
    sectionName: SectionName.AnimationsSection,
  }),
  {
    name: 'AnimationsSection',
    image: 'https://cdn.zappy.app/8df6a921d924e95ea2ef57b043358b2f.png',
    inputs: [
      {
        name: 'title',
        type: 'string',
        defaultValue: DEFAULT_VALUES.title,
        helperText:
          'The title of the entire section to be displayed in the sticky nav',
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
      {
        name: 'sections',
        type: 'list',
        subFields: [
          {
            name: 'heading',
            type: 'richText',
            defaultValue: `Connect your apps, <span style="color: ${Colors.zapier}">automate your work</span>`,
          },
          {
            name: 'description',
            type: 'richText',
            defaultValue:
              '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
          },
          { name: 'navLinkText', type: 'string', required: true },
          { name: 'animationDataUrl', type: 'string', required: true },
          { name: 'animationAssetsUrl', type: 'string' },
          { name: 'animationSpeed', type: 'number' },
          {
            name: 'mediaAltText',
            type: 'string',
            required: true,
            helperText:
              'Text that describes the animation for accessibility purposes',
          },
        ],
        defaultValue: [DEFAULT_VALUES.sections[0]],
      },
    ],
  },
);
